import { createSlice } from "@reduxjs/toolkit";

export interface DashboardKpi {
  count: number;
  percentage: number;
}

export interface DashboardAnalytics {
  visited?: DashboardKpi;
  registered?: DashboardKpi;
  trialStarted?: DashboardKpi;
  firstInvoice?: DashboardKpi;
  activeSubscriptions?: DashboardKpi;
  firstProduct?: DashboardKpi;
  [key: string]: DashboardKpi | undefined;
}

export interface DashboardState {
  loading: boolean;
  error: null | string;
  analyticsData: any;
  listLoading: boolean;
  actionsLoading: boolean;
}

const initialDashboardState: DashboardState = {
  loading: false,
  error: null,
  analyticsData: {},
  listLoading: false,
  actionsLoading: false,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: initialDashboardState,

  reducers: {
    catchError: (state, action) => {
      state.error = action.payload.error;
      // Do not keep showing the KPIs of the previous request (e.g. normal data after a failed funnel request)
      state.analyticsData = {};
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },

    startCall: (state, action) => {
      state.loading = true;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = true;
      }
    },

    getDashboardAnalytics: (state, action) => {
      state.loading = false;
      state.error = null;
      state.analyticsData = action.payload.results;
    },
  },
});
